import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditRecintosVisitaComponent } from "./edit-recintos-visita/edit-recintos-visita.component";

@Component({
  selector: "app-recintos-visita",
  templateUrl: "./recintos-visita.component.html",
  styleUrls: ["./recintos-visita.component.scss"],
})
export class RecintosVisitaComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditRecintosVisitaComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
